// @flow

/* eslint-disable */
import React, { Component } from 'react';

import Text from '../../shared/Typography'
import Button from '../../shared/Button';
import AppView from '../../layouts/AppView';

import Typography from './typography'
import Buttons from './buttons';
import Playground from './playground';
import Graphs from './graphs';
import Forms from './forms';
import Cards from './cards';
import Grid from './grid';
import Icons from './icons';


type State = {
  view: string
}

export default class PatternLibrary extends Component<void, State> {
  state: State = {
    view: 'Typography'
  }

  render() {
    const navItems = ['typography', 'buttons', 'cards', 'icons', 'forms', 'graphs', 'grid', 'playground']

    return (
      <AppView pageClassName='pattern-library'>

      <nav className='pattern-library__nav'>
        <Text h1 className='pattern-library__page-title'>Pattern Library</Text>
        <div>
          {navItems.map(item => (
            <Button
              label={item}
              onClick={() => this.setState({ view: item })}
              className={this.state.view === item ? 'is-primary pattern-library__nav-item' : 'is-secondary pattern-library__nav-item'} />
          ))}
        </div>
      </nav>

      <section className='pattern-library__components'>
        {this.state.view === 'typography' && <Typography />}
        {this.state.view === 'buttons' && <Buttons />}
        {this.state.view === 'graphs' && <Graphs />}
        {this.state.view === 'grid' && <Grid />}
        {this.state.view === 'forms' && <Forms />}
        {this.state.view === 'cards' && <Cards />}
        {this.state.view === 'icons' && <Icons />}
        {this.state.view === 'playground' && <Playground />}
      </section>

      </AppView>
    );
  }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/index.js